import motime from '@/common/utilities/motime';
import { mapGetters } from 'vuex';
const STATE_TIMEZONE_MAP = {
    AL: 'America/Chicago',
    AK: 'America/Anchorage',
    AZ: 'America/Phoenix',
    AR: 'America/Chicago',
    CA: 'America/Los_Angeles',
    CO: 'America/Denver',
    CT: 'America/New_York',
    DE: 'America/New_York',
    FL: 'America/New_York',
    GA: 'America/New_York',
    HI: 'Pacific/Honolulu',
    ID: 'America/Denver',
    IL: 'America/Chicago',
    IN: 'America/New_York',
    IA: 'America/Chicago',
    KS: 'America/Chicago',
    KY: 'America/New_York',
    LA: 'America/Chicago',
    ME: 'America/New_York',
    MD: 'America/New_York',
    MA: 'America/New_York',
    MI: 'America/New_York',
    MN: 'America/Chicago',
    MS: 'America/Chicago',
    MO: 'America/Chicago',
    MT: 'America/Denver',
    NE: 'America/Chicago',
    NV: 'America/Los_Angeles',
    NH: 'America/New_York',
    NJ: 'America/New_York',
    NM: 'America/Denver',
    NY: 'America/New_York',
    NC: 'America/New_York',
    ND: 'America/Chicago',
    OH: 'America/New_York',
    OK: 'America/Chicago',
    OR: 'America/Los_Angeles',
    PA: 'America/New_York',
    RI: 'America/New_York',
    SC: 'America/New_York',
    SD: 'America/Chicago',
    TN: 'America/Chicago',
    TX: 'America/Chicago',
    UT: 'America/Denver',
    VT: 'America/New_York',
    VA: 'America/New_York',
    WA: 'America/Los_Angeles',
    WV: 'America/New_York',
    WI: 'America/Chicago',
    WY: 'America/Denver',
    DC: 'America/New_York',
};

function getTimezoneByStateCode(stateCode) {
    if (!stateCode) return Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tz = STATE_TIMEZONE_MAP[String(stateCode).toUpperCase()];
    return tz || 'America/New_York';
}

function getTourScheduleInTimezone(stateCode, choice) {
    const tz = getTimezoneByStateCode(stateCode);
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour: 'numeric', hour12: false, year: 'numeric', month: 'numeric', day: 'numeric' });
    const parts = formatter.formatToParts(now);
    const hour = parseInt(parts.find((p) => p.type === 'hour').value, 10);
    const month = parseInt(parts.find((p) => p.type === 'month').value, 10);
    const day = parseInt(parts.find((p) => p.type === 'day').value, 10);
    const year = parseInt(parts.find((p) => p.type === 'year').value, 10);

    if (choice === 'asap') {
        let date = new Date();
        // after 2pm: date + 1
        if (hour > 14) {
            date.setDate(date.getDate() + 1);
        }
        return { date, timeDisplay: undefined };
    }
    if (choice === 'weekend') {
        const weekdayFormatter = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short' });
        const dayMap = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
        const currentDay = dayMap[weekdayFormatter.format(now)];

        let targetDate;
        if (currentDay < 6) {
            // Today is before Saturday, set to Saturday
            targetDate = new Date(year, month - 1, day);
            targetDate.setDate(targetDate.getDate() + (6 - currentDay));
        } else {
            // Today is Saturday, set to Sunday
            targetDate = new Date(year, month - 1, day);
            targetDate.setDate(targetDate.getDate() + 1);
        }
        return { date: targetDate, timeDisplay: undefined };
    }
    return { date: undefined, timeDisplay: undefined };
}

export default {
    name: 'propertyTourCta',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
    },
    methods: {
        openTourHotlead(choice) {
            const stateCode = this.dpp.geo && this.dpp.geo.stateCode;
            const isAnotherOrSingle = choice === 'another' || choice === 'single';
            const changeDate = isAnotherOrSingle;
            let date;
            let timeDisplay;
            let hotleadSub;
            let showHotleadSub = true;

            if (this.getSplit('movoto-tour-CW-4266', 'on1') || this.getSplit('movoto-tour-CW-4266', 'on2')) {
                showHotleadSub = false;
            }
            if (isAnotherOrSingle) {
                hotleadSub = 'When would you like to see this home?';
            }
            if (!isAnotherOrSingle && stateCode) {
                const schedule = getTourScheduleInTimezone(stateCode, choice);
                date = schedule.date;
                timeDisplay = schedule.timeDisplay || (schedule.date ? motime.formatDate(schedule.date, { month: 'short', day: 'numeric', raw: true }) : undefined);
            }
            if (date instanceof Date && !isNaN(date)) {
                const weekText = motime.toWeekDay(date);
                const dateText = motime.formatDate(date, { month: 'short', day: 'numeric', raw: true });
                const formatted = weekText + '., ' + dateText.replace(/(\w+)\s+(\d+)/, '$1. $2');
                hotleadSub = '<b class="text-bold">' + formatted + '</b>';
            }
            const opt = {
                hotleadType: 'InlineDatePicker',
                hotleadTitle: 'Request tour',
                buttonText: this.molang('dpp.hotleadForm.submit'),
                hideProfile: true,
                enableChangeDate: changeDate,
                propertyId: this.dpp.propertyId,
                propertyData: this.dpp,
                overwriteLeadTypeToBuy: true,
                showComment: false,
            };
            if (date) opt.date = date;
            if (timeDisplay) opt.timeDisplay = timeDisplay;
            if (hotleadSub && showHotleadSub) opt.hotleadSub = hotleadSub;
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtHotleadForm',
                trigger: 'propertyTourLink',
                opt,
            });
        },
    },
};
